import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)

export default {
  //state相当于一个内存，存储数据的，但是不能直接对state中的数据进行操作
  //需要mutations来操作state里面的数据
  state: {
    //左侧菜单数据
    menu_data: [],
    //菜单收缩属性
    isCollapse: false,
    //菜单路径
    menu_path: sessionStorage.getItem('menuPath') || '运行监控',
    position: []
  },
  mutations: {
    getMenuList (state, router) {
      //1.取出菜单数据
      let menuList = sessionStorage.getItem("menuList")
      //2.设置菜单数据
      if (menuList) {
        state.menu_data = JSON.parse(menuList)
      }
      //3.取出路由数据
      let oldRouterList = sessionStorage.getItem("routerList")
      let routerList = []
      if (oldRouterList) {
        routerList = JSON.parse(oldRouterList)
      }
      //4.动态的生成路由
      //4.1获取原来的路由
      let oldRouter = router.options.routes
      //4.2遍历后台返回的路由数据，动态生成路由
      routerList.forEach((item) => {
        item.component = () => import(`@/views${item.url}.vue`)
        oldRouter[3].children.push(item)
      })
      //5.添加到现有路由里面
      router.addRoutes(oldRouter)
    },
    //设置收缩菜单属性
    setOpenOrClose (state) {
      state.isCollapse = !state.isCollapse
    },
    savePosition (state, position) {
      state.position = position
    }
  },
  actions: {},
}
